export const EMAIL_NOTIFICATION_FETCH_DATA =
    "email_notifications/email_notifications_fetch_data"
export const EMAIL_NOTIFICATION_SUCCESS =
    "email_notifications/email_notifications_fetch_data_success"
export const EMAIL_NOTIFICATION_FAILURE =
    "email_notifications/email_notifications_fetch_data_failure"
export const CREATE_NEW_EMAILS = "email_notifications/create-new-emails"

export const CREATE_NEW_EMAILS_SUCCESS =
    "email_notifications/create-new-emails-success"
export const CREATE_NEW_EMAILS_FAILURE =
    "email_notifications/create-new-emails-failure"
export const UPDATE_EMAILS = "email_notifications/update-emails"
export const UPDATE_EMAILS_SUCCESS = "email_notifications/update-emails-success"

export const UPDATE_EMAILS_FAILURE = "email_notifications/update-emails-failure"

export const EMAIL_NOTIFICATION_RESET_SAVE =
    "email_notifications/email_notification_reset_save"
